import React from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { ColoursByStrength } from './constants';
import { container, indicator } from './styles';

const PasswordStrengthIndicator = ({ password }) => {
  const indicators = Object.keys(ColoursByStrength);
  const testString = password.trim();
  const indicatorItems = [];
  let strength = 0;

  if (!isEmpty(testString)) {
    strength++;
  }

  if (testString.length >= 8) {
    strength++;
  }

  if (/(?=.*[a-z])(?=.*[A-Z])/.test(testString)) {
    strength++;
  }

  if (/[0-9]/.test(testString)) {
    strength++;
  }

  if (/[_\W]/.test(testString)) {
    strength++;
  }

  const strengthType = indicators[strength - 1];
  const indicatorsToAvoidColor = indicators.length - strength;

  // for better flex management pushing components to array separately. Using map will enforce to
  // return aparent div, which will affect flex-box count and hence size of items as well.
  for (let ind = 0; ind < indicators.length; ind++) {
    indicatorItems.push(
      <div
        key={`indicator-${ind}`}
        style={{
          ...indicator,
          backgroundColor:
            ind + 1 > indicatorsToAvoidColor
              ? ColoursByStrength[strengthType]
              : '#D5D5D5',
        }}
      />
    );

    if (ind !== indicators.length - 1) {
      indicatorItems.push(<div key={`separator-${ind}`} style={indicator} />);
    }
  }

  return (
    <div className="psi" style={container}>
      {indicatorItems}
    </div>
  );
};

PasswordStrengthIndicator.propTypes = {
  password: PropTypes.string.isRequired,
};

export default PasswordStrengthIndicator;
